export default __webpack_public_path__ + "static/media/4.fab0701d.jpg";